// AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add a loading state

  // Check for an existing token on component mount
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      validateToken(token);
    } else {
      setLoading(false); // No token, stop loading
    }
  }, []);

  // Validate the token with the server
  const validateToken = async (token) => {
    try {
      const response = await fetch("https://otp-bakend.onrender.com/protected", {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
  
      if (response.ok) {
        const data = await response.json();
        console.log("Backend Response:", data); // Debugging
        setUser(data.user); // Ensure data.user includes { email, department }
      } else {
        localStorage.removeItem("authToken"); // Remove invalid token
      }
    } catch (error) {
      console.error("Token validation error:", error);
      localStorage.removeItem("authToken"); // Remove invalid token
    } finally {
      setLoading(false); // Stop loading after validation
    }
  };

  // Login function to set the user and store the token
  const login = (userData, token) => {
    setUser(userData); // userData should include { email, department }
    localStorage.setItem("authToken", token);
  };

  // Logout function to clear the user and token
  const logout = () => {
    setUser(null);
    localStorage.removeItem("authToken");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = () => useContext(AuthContext);